<template>
  <div class="row">
    <div class="col-md-3">
      <div class="form-group">
        <label for="">Источник</label>
        <select @change="change($event, 'site')" :disabled="disableLocal || disableProjectSelect" v-model="project"
                class="form-control">
          <option value="0" disabled>Выберите проект</option>
          <option v-for="(id, index) in projects" :value="id">{{ $AllProjects[id].title }}</option>
        </select>
      </div>
      <div class="form-group" v-if="$AllProjects[project] && $AllProjects[project].mirrors.length">
        <label for="">Зеркало</label>
        <select @change="change($event, 'mirror')" :disabled="disableLocal" v-model="mirror" class="form-control">
          <option selected value="0">Выберите зеркало</option>
          <option v-for="(pMirror) in $AllProjects[project].mirrors" :value="pMirror.id">{{ pMirror.title }}</option>
        </select>
      </div>
    </div>
    <div class="col-md-3">
      <div class="form-group">
        <label for="">Город</label>
        <select @change="change($event, 'city')" :disabled="disableLocal || disableCitySelect || !project"
                v-model="city"
                class="form-control">
          <option value="-1" disabled>Выберите город</option>
          <option v-for="(city, index) in getSortedCities(cities[project])" :value="city.id">{{ city.name }}
          </option>
        </select>
      </div>
    </div>

    <div class="col-md-3">
      <div class="form-group" v-if="selectDivisionRequire">
        <label>Выберите дивизион</label>
        <select @change="change($event, 'division')" v-model="$editNewOrder.division_id" class="form-control">
          <option v-for="d in divisionsForSelect" :value="d.id">{{ d.title }}</option>
        </select>
      </div>
    </div>

    <div v-if="city == 1" class="col-md-3">
      <div class="form-group">
        <label class="pointer" for="useInternationalDelivery">
          <input type="checkbox" :disabled="disableAll" @change="updateDelivery" v-model="useInternationalDelivery"
                 id="useInternationalDelivery">
          Доставка в другую страну
        </label>
        <select :disabled="disableAll" @change="change($event, 'responsible_agent_id')" v-model="responsible_agent_id"
                class="form-control">
          <option v-for="(agent) in agentsToSelect" :value="agent.id">{{ agent.countryName }} ({{
              agent.name
            }})
          </option>
        </select>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: ['onUpdate', 'customData'],
  data() {
    return {
      project: null,
      city: null,
      projects: {},
      mirror: 0,
      cities: {},
      selectDivisionRequire: false,
      divisionsForSelect: [],
      disableLocal: false,
      disableProjectSelect: false,
      disableCitySelect: false,
      disableAll: false,
      responsible_agent_id: 174,
      useInternationalDelivery: false,
      allCities: {},
      agentsToSelect: [
        //TODO get agents from DB
        {
          id: 174,
          countryName: 'Белоруссия',
          name: 'Сергей',
          currency_id: 38,
        }
      ],
    }
  },
  created() {
    if (this.$currentRole === 'admin') this.selectDivisionRequire = true;
    const allCountries = this.$AllCountries.reduce((acc, c) => {
      acc[c.id] = c;
      return acc;
    }, {})
    const list = Array.isArray(this.$AllCities) ? [...this.$AllCities] : Object.values(this.$AllCities);
    this.allCities = list.reduce((acc, c) => {
      acc[c.id] = {...c, country: allCountries[c.country_id]}
      return acc;
    }, {})
    const fixedSorting = [1, 2, 0];
    if (this.$currentRole === 'admin'
      || this.$currentUserRoles.includes('supervisor')
      || this.$currentUserRoles.includes('admin') || (this.$editNewOrder && [1, 2, 3].includes(+this.$editNewOrder.status))) {
      this.projects = Object.keys(this.$AllProjects).filter((pId) => this.$AllProjects[pId].is_active)
      this.cities = this.projects.reduce((acc, p) => {
        if (!acc[p]) acc[p] = []
        let allCities = _.orderBy(this.$AllCities, ['name'])
        acc[p] = [...fixedSorting];
        acc[p] = [...acc[p], ...allCities.filter((c) => !fixedSorting.includes(c.id)).map((c) => c.id)]
        return acc
      }, {})
    } else {
      if (this.$orderAccess.all) {
        this.projects = Object.keys(this.$AllProjects).filter((pId) => this.$AllProjects[pId].is_active);
      } else {
        this.projects = Object.keys(this.$orderAccess).length ? Object.keys(this.$orderAccess) : Object.keys(this.$AllProjects).filter((pId) => this.$AllProjects[pId].is_active);
      }
      let cities = this.projects.reduce((acc, p) => {
        if (!acc[p]) acc[p] = []
        if (this.$orderAccess.all || (this.$orderAccess[p] && this.$orderAccess[p].all) || !(this.$orderAccess ?? []).length) {
          let allCities = _.orderBy(this.$AllCities, ['order', 'name'])
          acc[p] = [...fixedSorting];
          acc[p] = [...acc[p], ...allCities.filter((c) => !fixedSorting.includes(c.id)).map((c) => c.id)]
        } else {
          acc[p] = Object.keys(this.$orderAccess[p])
        }
        // acc[p].push()
        return acc
      }, {})
      this.cities = cities
    }
    if ((this.$editNewOrder && this.$editNewOrder.id) || this.$editNewOrder.type_id === 2) {
      this.city = this.$editNewOrder.city_id
      this.project = this.$editNewOrder.site_id
      this.mirror = this.$editNewOrder.site_mirror_id || null
      this.useInternationalDelivery = this.$editNewOrder.type_id === 3
    } else {
      // this.project = this.projects[0]
      this.project = 0
      // this.city = this.cities[this.project][0]
    }
    if (this.$editNewOrder.status !== undefined && ![0, 9999].includes(+this.$editNewOrder.status)) {
      this.disableAll = this.disableLocal = true
    }
    if (this.customData) {
      if (this.customData.project) this.project = this.customData.project;
      if (this.customData.city) this.city = this.customData.city;
      if (this.customData.disableProjectSelect) this.disableProjectSelect = this.customData.disableProjectSelect;
    }

    this.updateDivisionSelect();
    this.updateData();
  },
  watch: {
    'city': {
      handler: function (val, oldVal) {
        this.updateDivisionSelect();
      }
    }
  },
  computed: {
    $editNewOrder() {
      return this.$store.getters['orders/editNewOrder']
    },
    $AllCountries() {
      return this.$store.getters['platform/countries'];
    },
    $AllProjects() {
      return this.$store.getters['platform/projects'].reduce(
        (acc, p) => {
          acc[p.id] = {...p}
          return acc
        },
        {}
      )
    },
    $AllCities() {
      return this.$store.getters['platform/cities']
    },
    $AllDivisions() {
      return this.$store.getters['platform/divisions']
    },
  },
  methods: {
    getCityTitleById(id) {
      return (this.allCities[id].country.id !== 3 ? '(' + this.allCities[id].country.title + ') ' : '') + this.allCities[id].name;
    },
    updateOrder() {

    },
    updateDivisionSelect() {
      // if (this.$currentRole !== 'admin') this.selectDivisionRequire = false;
      // this.$editNewOrder.division_id = null;
      const divisionsForSelect = Object.values(this.$AllDivisions).reduce((acc, d) => {
        if (d.is_active && d.cities.filter((c) => c.is_active).map((c) => c.object_id).includes(+this.$editNewOrder.city_id)) {
          acc.push({...d});
        }
        return acc;
      }, []);
      if (divisionsForSelect.length > 1 || this.$currentRole === 'admin') {
        this.selectDivisionRequire = true;
        this.divisionsForSelect = divisionsForSelect;
      }
      if (!this.$editNewOrder.division_id || !(divisionsForSelect.map((d) => d.id).includes(this.$editNewOrder.division_id))) {
        if (divisionsForSelect[0]?.id) {
          this.$editNewOrder.division_id = divisionsForSelect[0].id;
        }
      }
    },
    updateData() {
      if (this.onUpdate) {
        this.onUpdate({
          city_id: this.city,
          site_id: this.project,
          division_id: this.$editNewOrder.division_id,
          mirror: this.mirror
        })
      }
    },
    change(e, type) {
      // console.log(type, e.target.value, this.$editNewOrder.division_id);
      if (type === 'site') {
        this.disableCitySelect = false;
        // console.log(this.project)
        // this.city = this.cities[this.project][0]
        // this.mirror = 0;
        // this.city = -1;
        this.mirror = 0
        if (+this.project === 14) {
          this.city = 1;
          this.disableCitySelect = true;
        }
      }
      this.updateData()
    },
    updateDelivery() {
      this.disableLocal = this.useInternationalDelivery
      //TODO if order refund ????
      this.$editNewOrder.type_id = this.useInternationalDelivery ? 3 : 1
      if (this.useInternationalDelivery) {
        this.$editNewOrder.responsible_agent_id = this.responsible_agent_id
      }
    },
    getSortedCities(ids = []) {
      const notInArray = [0, 1, 2]
      let arr = [];
      if (ids.includes(1)) {
        arr.push(Object.values(this.$AllCities).find((c) => c.id === 1));
      }
      if (ids.includes(2)) {
        arr.push(Object.values(this.$AllCities).find((c) => c.id === 2));
      }
      if (ids.includes(0)) {
        arr.push(Object.values(this.$AllCities).find((c) => c.id === 0));
      }
      return [...arr, ...(_.orderBy(Object.values(this.$AllCities).filter((c) => !notInArray.includes(c.id)), 'name'))]
    },
  }
}
</script>
